import { ContainerWidthClasses } from '@homeflow/v4-lib/theme/sections/container.component';

const sharedClasses = 'container relative w-full mx-auto px-6 ';

export const containerWidthClasses: ContainerWidthClasses = {
  full: '',
  large: sharedClasses + 'max-w-7xl',
  medium: sharedClasses + 'max-w-5xl',
  small: sharedClasses + 'max-w-3xl',
  fallback: sharedClasses + 'max-w-7xl',
};
